// @ts-check
import { Flex } from '~/design-system'; // @ts-ignore

/**
 *
 * @param {object} props
 * @param {boolean} [props.sticky] Determines if the menu is sticky.
 * @param {import('react').ReactNode} [props.children]
 */
export default function TabbedMenu({ sticky, children, ...rest }) {
  return (
    <Flex
      sx={{
        display: 'flex',
        backgroundColor: 'white',
        borderBottom: 1,
        borderColor: 'border',
        alignItems: 'flex-end',
        ...(sticky && { position: 'sticky', top: 'navbar' }),
        marginX: 2,
        zIndex: 'header', // This is only necessary within Bottlebooks dashboard, so tables don't appear above the menu.
      }}
      {...rest}
    >
      {children}
    </Flex>
  );
}
